import React from 'react';

/**
 * Shared visibility toggle button used across all template components.
 * Renders an eye/eye-off icon with "Visible"/"Hidden" text.
 */
export default function VisibilityToggle({ section, hiddenSections, onToggleSection }) {
  if (!onToggleSection) return null;

  const isHidden = hiddenSections.includes(section);

  return (
    <button
      className={`section-visibility-toggle${isHidden ? ' is-hidden' : ''}`}
      onClick={() => onToggleSection(section)}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {isHidden ? (
          <>
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </>
        ) : (
          <>
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </>
        )}
      </svg>
      {isHidden ? 'Hidden' : 'Visible'}
    </button>
  );
}
